import { parsePhoneNumber } from "awesome-phonenumber";

import { toApiPhoneAreaCode } from "./phone";

export const getSignupInput = (values) => {
  const parsedPhone = parsePhoneNumber(values.phoneNumber);
  const PhoneAreaCode = toApiPhoneAreaCode(parsedPhone.countryCode);
  const PhoneNumber = parsedPhone.number?.significant;

  // A number the parser cannot read has neither part, and sending it anyway
  // would store "+undefined" as the travel account's calling code.
  if (!PhoneAreaCode || !PhoneNumber) {
    throw new Error("The phone number could not be parsed");
  }

  return {
    PhoneAreaCode,
    PhoneNumber,
    firstName: values.firstName,
    lastName: values.lastName,
    password: values.password,
    email: values.email,
    ...(values.country ? { countryId: Number(values.country) } : {}),
    ...(values.country && values.city ? { areaId: Number(values.city) } : {}),
    ...(values.gender ? { gender: values.gender } : {}),
    ...(values.birthDate ? { birthDate: values.birthDate } : {}),
  };
};
